<template>
    <div class="addressBook">
        <div class="addressBook_top">
            <div class="addressBook_top_add" @click="addPersonEvent">
                +
            </div>
            <div class="addressBook_top_right">
                <div class="addressBook_top_search">
                    <el-input
                        v-model="formData.search"
                        placeholder="请输入"
                    >
                        <template #prefix>
                            <el-icon class="el-input__icon"><search /></el-icon>
                        </template>
                    </el-input>
                </div>
                <div class="addressBook_top_btn" @click="searchEvent">
                    搜索
                </div>
            </div>

        </div>
        <div class="tableComponent">
            <!--:max-height="tableMaxheight"-->
            <el-table lazy
                      ref="eltable" :data="tableData" height="100%" scrollbar-always-on="true"
                      style="width: 100%">
                <el-table-column type="index" align="center" label="序号" width="100" />
                <el-table-column prop="xm" label="姓名" min-width="13%" />
                <el-table-column prop="rygl" label="人员类型" min-width="13%" />
                <el-table-column prop="dwmc" label="单位名称" min-width="13%" />
                <el-table-column prop="sjhm" label="手机号码" min-width="13%" />
                <el-table-column prop="zjmh" label="座机号码" min-width="13%" />
                <el-table-column align="center" header-align="center" min-width="27%">
                    <template
                        slot="header"
                        #header="scope"
                    >
                        <div class="opreate">
                            <span>操作</span>
                        </div>
                    </template>
                    <template #default="scope">
                        <div class="opreateBtns">
                            <div class="addressBook_bjBtn" @click="editeEvent(scope.row)">
                                <img src="../../assets/images/edit-outline@2x.png" alt="">编辑
                            </div>
                            <div class="addressBook_bjBtn" @click="deleteEvent(scope.row)">
                                <img src="../../assets/images/edit-outline@2x.png" alt="">删除
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="jsjb_buttonPage">
            <div class="jsjb_button">
                <!--<div class="jsjb_button_list" @click="extExcel">-->
                    <!--<i class="icon-file-excel"></i>导出Excel-->
                <!--</div>-->
                <!--<div class="jsjb_button_list">-->
                    <!--<i class="icon-file-wordine"></i>导出word-->
                <!--</div>-->
                <!--<div class="jsjb_button_list">-->
                    <!--<i class="icon-liucheng"></i>导出Wrod(流程)-->
                <!--</div>-->
                <!--<div class="jsjb_button_list">-->
                    <!--<i class="icon-alarmClock"></i>催办-->
                <!--</div>-->
            </div>
            <el-pagination
                v-model:page-size="formData.pageSize"
                v-model:current-page="formData.pageNum"
                :page-sizes="[50, 100,150, 200]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rowsCount"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <div class="modal"  v-if="addPersonModal">
            <div class="modal_content addPerson">
                <div class="modal_title">
                    <p>{{modalstate=='add'?'新增':'修改'}}人员</p>
                    <svg @click="addPersonModal=false" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""
                    >
                        <path fill="currentColor"
                              d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336L512 457.664z"></path>
                    </svg>
                </div>
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    label-position="left"
                    ref="ruleFormRef"
                >
                <div class="modal_main">
                        <el-form-item label="姓名" prop="xm">
                            <el-input v-model="ruleForm.xm"/>
                        </el-form-item>
                        <el-form-item label="单位名称" prop="dwmc">
<!--                            <el-select v-model="ruleForm.dwmc" placeholder="请选择">-->
<!--                                <el-option v-for="item in dwmcSelect" :label="item.label" :value="item.value" />-->
<!--                            </el-select>-->
                            <el-cascader
                                v-model="ruleForm.dwmc"
                                :options="dwmcSelect"
                                :props="{
                                    emitPath:false,
                                    label:'label',
                                    value:'label'
                                }"
                                clearable
                                filterable
                            />
                        </el-form-item>
                        <el-form-item label="人员管理" prop="rygl">
                            <el-select v-model="ruleForm.rygl" placeholder="请选择">
                                <el-option v-for="item in ryglSelect" :label="item.roleName" :value="item.roleName" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="sjhm">
                            <el-input v-model="ruleForm.sjhm"/>
                        </el-form-item>
                        <el-form-item label="座机号码">
                            <el-input v-model="ruleForm.zjmh"/>
                        </el-form-item>

                </div>
                    <div class="modal_footer">
                        <div class="modal_footer_btn" @click="addPersonModal=false">
                            取消
                        </div>
                        <div class="modal_footer_btn confirmBtn" @click="submitForm(ruleFormRef)">
                            确认
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, computed,onMounted, ref,getCurrentInstance} from 'vue'
    import { Search } from '@element-plus/icons-vue'
    export default {
        name: "AddressBook",
        setup(){
            const {proxy} = getCurrentInstance();
            let tableData = ref()
            let formData = ref({
                search:"",
                "pageNum": 1,
                "pageSize": 12
            })
            let rowsCount = ref(100);
            const addPersonEvent =()=>{
                for(let key in ruleForm){
                    ruleForm[key] = "";
                }

                addPersonModal.value= true;
                modalstate.value = "add"
                console.log(modalstate.value)
            }
            //新增人员弹框
            let modalstate = ref("add")
            let addPersonModal = ref(false)
            const ruleFormRef = ref()
            const ruleForm = reactive({
                xm: "",
                dwmc: "",
                rygl: "",
                sjhm: "",
                zjmh: "",
                id:""
            });
            const rules = ref({
                xm: [
                    {required: true, message: "请输入姓名", trigger: 'blur'},
                ],
                dwmc: [
                    {required: true, message: "请选择单位名称", trigger: 'blur'},
                ],
                rygl: [
                    {required: true, message: "请选择单位名称", trigger: 'blur'},
                ],
                sjhm: [
                    {required: true, message: "请输入手机号码", trigger: 'blur'},
                ],
            })
            const submitForm = (param)=>{
                if (!param) return
                let url = ""
                if(modalstate.value =='add'){
                    url = "/jgfast/txl/insTxl"
                }else if(modalstate.value =='xg'){
                    url = "/jgfast/txl/updTxl"
                }
                param.validate((valid, fields) => {
                    if (valid) {
                        proxy.$axios.post(url, ruleForm).then((res) => {
                            addPersonModal.value = false
                            // ruleForm.xm = "";
                            // ruleForm.dwmc = "";
                            // ruleForm.rygl = "";
                            // ruleForm.sjhm = "";
                            // ruleForm.zjmh = "";
                            // ruleForm.id = "";

                            tableRequst();
                        });
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            }
            const editeEvent =(param)=>{
                addPersonModal.value= true;
                modalstate.value = "xg";
                ruleForm.xm = param.xm;
                ruleForm.dwmc = param.dwmc;
                ruleForm.rygl = param.rygl;
                ruleForm.sjhm = param.sjhm;
                ruleForm.zjmh = param.zjmh;
                ruleForm.id = param.id;
            }
            const deleteEvent =(param)=>{
                proxy.$axios.post("/jgfast/txl/delTxl", {"id": param.id }).then((res)=>{
                    tableRequst()
                })
            }
            const tableRequst = ()=>{
                proxy.$axios.post("/jgfast/txl/selTxllb", formData.value).then((res)=>{
                    tableData.value = res.data.vbs;
                    rowsCount.value = res.data.rowsCount;
                })
            }
            let dwmcSelect = ref()
            let ryglSelect = ref()
            const handleSizeChange =(param)=>{
                tableRequst()
            }
            const handleCurrentChange = (param)=>{
                tableRequst()
            }
            const searchEvent =()=>{
                tableRequst()
            }
            onMounted(()=>{
                tableRequst();
                proxy.$axios.get("/jgfast/txl/selRoleList").then((res)=>{
                    ryglSelect.value = res.data
                })
                proxy.$axios.get("/jgfast/txl/selDw").then((res)=>{
                    dwmcSelect.value = res.data
                })
            })
            return{
                Search,
                rowsCount,
                formData,
                tableData,
                ruleFormRef,
                ruleForm,
                addPersonModal,
                modalstate,
                addPersonEvent,
                submitForm,
                rules,
                editeEvent,
                deleteEvent,
                dwmcSelect,
                ryglSelect,
                handleSizeChange,
                handleCurrentChange,
                searchEvent
            }
        }
    }
</script>

<style scoped>

</style>
